import { useQuery } from '@tanstack/react-query';
import { getMenuDataUrlApi } from '../utils/apis';
import { IgetMenuData } from '../schemas/apis/interface';
import { useUser } from './useUser';

export const useMenuData = (
  { folderPath, fileName, tenantName }: IgetMenuData,
  publishEventsLoaded = false,
  selectedStore: any
) => {
  const { user } = useUser();
  const {
    data: menuDataUrl,
    isLoading: menuDataUrlLoading,
    isError: menuDataUrlError,
  } = useQuery({
    queryKey: [
      'menuDataUrl',
      folderPath,
      fileName,
      selectedStore?.id,
      user?.tenantName,
    ],
    queryFn: () => getMenuDataUrlApi({ folderPath, fileName, tenantName }),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    enabled:
      publishEventsLoaded &&
      folderPath !== '' &&
      fileName !== '' &&
      !!user?.tenantName &&
      !!selectedStore,
  });

  const {
    data: menuData,
    isLoading: menuDataLoading,
    isError: menuDataError,
  } = useQuery({
    queryKey: ['menuData', selectedStore?.id, user?.tenantName],
    queryFn: async () => {
      if (!menuDataUrl?.data?.presigned_url) {
        throw new Error('Presigned URL not available');
      }
      const response = await fetch(menuDataUrl.data.presigned_url);
      const data = await response.json();
      return data;
    },
    enabled: !!menuDataUrl?.data?.presigned_url,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    retry: 0,
  });

  return {
    isLoading: menuDataUrlLoading || menuDataLoading,
    error: menuDataUrlError || menuDataError,
    menuDataUrl,
    menuDataUrlLoading,
    data: menuData,
    menuDataLoading,
  };
};
